import {http} from "./api/restApiClient";
import {ApiResponse} from "apisauce";

import {ImportExportHistory} from "../pages/page-admin-organizations-users/utils/types";
import {
  CreateOrganizationRequest,
  OrganizationModel,
  UpdateOrganizationRequest,
} from "../utils/types/organization";
import {FacilityModel} from "../utils/types/facility";
import {Page} from "./api/pagination";

export type FacilityCodeModel = {
  name: string;
  code: string;
};

export const OrganizationsService = {
  // Note: can't use generated endpoint, as we can't pass query to it.
  get: (query: any): Promise<ApiResponse<Page<OrganizationModel>>> =>
    http.get("/organizations", query),

  find: (organizationId: string): Promise<ApiResponse<OrganizationModel>> =>
    http.get(`/organizations/${organizationId}`),

  create: (
    data: CreateOrganizationRequest,
  ): Promise<ApiResponse<OrganizationModel>> =>
    http.post("/organizations", data),

  update: (
    organizationId: string,
    data: UpdateOrganizationRequest,
  ): Promise<ApiResponse<OrganizationModel>> =>
    http.put(`/organizations/${organizationId}`, data),

  getOrganizationFacilities: (
    organizationId: string,
  ): Promise<ApiResponse<FacilityModel[]>> =>
    http.get(`/organizations/${organizationId}/facilities`),

  getOrganizationFacilityCodes: (
    organizationId: string,
  ): Promise<ApiResponse<{facilityCodes: FacilityCodeModel[]}>> =>
    http.get(`/organizations/${organizationId}/facility-codes`),

  importExportUsers: {
    getImportExportHistory: (organizationId: string) =>
      http.get<Array<ImportExportHistory>>(
        `import-export/organizations/${organizationId}/users`,
      ),
    getOrganizationUsersExport: (organizationId: string) =>
      http.get(`import-export/organizations/${organizationId}/users/export`),
    uploadFile: (organizationId: string, file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      return http.post(
        `import-export/organizations/${organizationId}/users`,
        formData,
      );
    },
  },
};
